import React, { Component } from "react";

// Global Contexts
import { ShoppingCartContext } from "contexts/shoppingCartContext.js";

// Global Components
import Button from "components/button/button";

// Local Styling
import "./buyButton.css";
import "./buyButton-mobile.css";

class BuyButton extends Component {
  constructor(props) {
    super(props);

    this.buyItem = this.buyItem.bind(this);
  }

  buyItem(checkout, variantId, callback) {
    checkout.addLineItem(
      {
        variantId,
        quantity: 1
      },
      callback
    );
  }

  render() {
    const variant = this.props.variant;
    // if size and color selected, allow purchasing
    if (variant !== null) {
      return (
        <div
          className={`buyButton ${this.props.mobile === true ? "mobile" : ""}`}
        >
          <ShoppingCartContext.Consumer>
            {checkout => (
              <Button
                color="orange"
                onClick={() =>
                  this.buyItem(checkout, variant.id, this.props.callback)
                }
              >
                <p>
                  Add to Cart
                  <span style={{ letterSpacing: "-6px", paddingLeft: "7px" }}>
                    ––––›
                  </span>
                </p>
              </Button>
            )}
          </ShoppingCartContext.Consumer>
        </div>
      );
    }
    // if size and color not selected, disable button
    return (
      <div
        className={`buyButton disabled ${
          this.props.mobile === true ? "mobile" : ""
        }`}
      >
        <Button color="orange">
          <p>
            {variant !== null && variant.available === false
              ? "Sold Out "
              : "Select Options"}
            {variant !== null && variant.available === false && (
              <span style={{ letterSpacing: "-6px", paddingLeft: "7px" }}>
                ––––›
              </span>
            )}
          </p>
        </Button>
      </div>
    );
  }
}

export default BuyButton;
